

import { DialogService } from 'primeng/dynamicdialog';

import { Injectable } from '@angular/core';

import { SelectItemComponent } from './select-item.component';

@Injectable({
  providedIn: 'root'
})
export class SelectItemService {

  constructor(
    private dialogService: DialogService
  ) { }

  selectItem(header: string, items: any[], visibleField = 'label') {
    return this.dialogService.open(SelectItemComponent, {
      header,
      width: window.innerWidth < 800 ? '100%' :'235px',
      data: {
        items,
        visibleField
      }
    });
  }
}
